export class BrowserConstants {

    public static KEYBOARD_BACKSPACE_CODE: number = 8;


}
